import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { DashboardPage } from "../features/dashboard/DashboardPage";

export const Route = createFileRoute("/dashboard")({
  component: () => (
    <RequireAuth>
      {(user) => (
        <DashboardPage
          uid={user.uid}
          email={user.email}
          signOut={user.signOut}
        />
      )}
    </RequireAuth>
  ),
});
